<template>
  <modal class="modal--welcomeback modal--zero-balance" :modal-key="'searching_specific_opponent'" @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_users_search_specific_user_title }}</h1>
      <img class="pinicon" src="static/images/challenge_icon.svg" alt="">
    </template>
    <template slot="body">
      <search-user :is-modal="true"/>
      <user-list :is-modal="true">
        <h2 slot="header">{{ getTranslations.home_users_search_user_your_list }}</h2>
        <template slot="content">
          <favorite-user v-for="(user, index) in getFavoriteUsers"
                         v-if="index < 3*page"
                         :avatar="user.avatar"
                         :username="user.username"
                         :level="user.level"
                         :key="index"/>
          <a href="#"
             @click.prevent="showMore()"
             v-if="getFavoriteUsers.length > 3"
             class="load-more btn2 btn2--std btn2--small btn2--green">
            ···
          </a>
        </template>
      </user-list>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchUser from '@/components/home/users/SearchUser';
import FavoriteUser from '@/components/home/users/FavoriteUser';
import UserList from '@/components/home/shared/GenericList';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'search-specific-user',
  provide: {
    isModal: true,
  },
  components: {
    SearchUser,
    FavoriteUser,
    UserList,
    Modal,
  },
  data() {
    return {
      page: 1,
    };
  },
  mounted() {
    this.fetchFavoriteUsers();
  },
  methods: {
    ...mapActions('users', [
      'fetchFavoriteUsers',
    ]),
    showMore() {
      this.page = this.page + 1;
    },
  },
  computed: {
    ...mapGetters('users', [
      'getFavoriteUsers',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/SearchSpecificOpponent.vue